<div class="flex flex-col gap-2">
  @if (this.hasIntroductions()) {
  <p-stepper
    [value]="1"
    class="basis-[50rem]"
  >
    <p-step-list>
      @for (intro of this.introductions; track $index) {
      <p-step [value]="$index + 1">{{ intro.title }}</p-step>
      }
    </p-step-list>

    <p-step-panels>
      @for (intro of this.introductions; track $index) {
      <p-step-panel [value]="$index + 1">
        <ng-template
          #content
          let-activateCallback="activateCallback"
        >
          <div class="flex flex-col">
            <h3>{{ intro.title }}</h3>
            <div [innerHTML]="intro.content"></div>
          </div>

          <div class="flex pt-6 justify-between">
            @if ($index > 0) {
            <p-button
              label="Zurück"
              severity="secondary"
              icon="pi pi-arrow-left"
              (onClick)="activateCallback($index)"
            />
            } @else {
            <div></div>
            }

            @if (this.isLastStep($index)) {
            <p-button
              label="Starten"
              icon="pi pi-play-circle"
              iconPos="right"
              (onClick)="this.start()"
            />
            } @else {
            <p-button
              label="Weiter"
              icon="pi pi-arrow-right"
              iconPos="right"
              (onClick)="activateCallback($index + 2)"
            />
            }
          </div>
        </ng-template>
      </p-step-panel>
      }
    </p-step-panels>
  </p-stepper>
  } @else {
  <p>Keine Einleitungstexte für diese Kategorie hinterlegt.</p>
  <div class="flex pt-6 justify-end">
    <p-button
      label="Starten"
      icon="pi pi-play-circle"
      iconPos="right"
      (onClick)="this.start()"
    />
  </div>
  }
</div>